import './terminus330/style';
import FormStructure from './terminus330/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js